import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';

export interface INodeLocation {
	x: number;
	y: number;
}

export type NodeLocation = ReadonlyRecord<INodeLocation>;

export const NodeLocationFactory = Record<INodeLocation>({
	x: null,
	y: null
});

export const NodeLocationFactoryFromJS = (data: INodeLocation) =>
	NodeLocationFactory({
		x: data.x,
		y: data.y
	});
